// Balance Import validates against the previously submitted Static Data submission. This map says where
// each `{ source: "external", keySet }` rule reference resolves: the Static Data worksheet and the
// column(s) whose values form the accepted set. `fields` is a union — a value in any listed column passes.
// "…WithinDevelopment" scoping is not expressible as a flat set and is not attempted.
// Entries are checked against STATIC_DATA_FIELDS at startup, so they can't silently drift.
// Imported by the validation worker, so no services imports here.

export type ExternalKeySetDefinition = {
  worksheet: string;
  fields: string[];
};

export const STATIC_DATA_KEY_SETS: Record<string, ExternalKeySetDefinition> = {
  "staticData.plAccounts.plNumberOrName": { worksheet: "PL Accounts", fields: ["PL_Number", "Name"] },
  "staticData.developments.developmentName": { worksheet: "Developments", fields: ["Development Name"] },
  "staticData.developments.developmentNumber": { worksheet: "Developments", fields: ["Development Number"] },
  "staticData.fundSchedules.descriptionWithinDevelopment": { worksheet: "Fund Schedules", fields: ["Description"] },
  "staticData.properties.propertyUniqueIdentifierOrPropertyId": {
    worksheet: "Properties",
    fields: ["Property Unique Identifier", "Property ID"],
  },
  "staticData.fiscalPeriods.descriptionOrPeriod": {
    worksheet: "Fiscal Period",
    fields: ["Description", "Financial Period"],
  },
  "staticData.freeholders.freeholderNoOrName": {
    worksheet: "Freeholders",
    fields: ["Freeholder No", "Freeholder Name"],
  },
  "staticData.nominalCodes.codeOrDescription": { worksheet: "Nominal Codes", fields: ["Code", "Description"] },
};

export function externalKeySetWorksheets(): string[] {
  return [...new Set(Object.values(STATIC_DATA_KEY_SETS).map((definition) => definition.worksheet))];
}
